document.addEventListener("DOMContentLoaded", function() {
  var contentAreas = document.querySelectorAll('.content_area');

  contentAreas.forEach(function(area) {
    area.addEventListener('click', function() {
      contentAreas.forEach(function(otherArea) {
        if (otherArea !== area) {
          otherArea.classList.remove('active');
        }
      });
      area.classList.toggle('active');

      // Get the active parent
      var parentActive = document.querySelector('.content_area.active');
      if (parentActive) {
        var element = parentActive.querySelector('.faq-accod-tittle');

        if (element) {
          var scrollDiv = element.offsetTop;
          window.scrollTo({
            top: scrollDiv - 61,
            behavior: 'smooth'
          });
        }
      }
    });
  });
});
